<template>
    <footer class="footer" style="background-image : url('img/custom/whowebackground.svg')">
        <div class="container" >
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://x.com/RaginiS_Shankar"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/diary_ofa_coach"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.linkedin.com/in/ragini-shankar-sinha/"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow on Linkedin">
                        <i class="fa fa-linkedin"></i>
                    </a>
                </div>
            </div>
            <div class="row align-items-center my-md">
                <div class="col-md-8">
                    <div class="media d-flex align-items-center">
                        <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                            <i class="ni ni-email-83"></i>
                        </div>
                        <div class="media-body ml-3">
                            <h6 class="heading text-primary mb-md-1">mails@raginisinha.in</h6>
                        </div>
                    </div>
                    <div class="media d-flex align-items-center mt-4">
                        <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                            <i class="ni ni-pin-3"></i>
                        </div>
                        <div class="media-body ml-3">
                            <h6 class="heading text-success mb-md-1">New Delhi, India</h6>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                        <img src="logo_black.png" style="height : 95px">
                    </a>
                </div>

                
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; 2020 All rights reserved | Managed by Strofes Technologies Private Limited <a href="" target="_blank" style="display : none">Creative Tim</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <router-link to="/book-now" class="nav-link text-dark">Book Now</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contact-me" class="nav-link text-dark">Contact Me</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
